/** Query-constraint classes (where / orderBy / limit / select / cursors). */

import type { Protocol } from './protocol';

/**
 * Extensible Query Constraint System
 */
export interface QueryConstraint {
  readonly type: string;
  apply(options: Protocol.QueryOptions): void;
}

export class WhereConstraint implements QueryConstraint {
  readonly type = 'where';
  constructor(
    private field: string,
    private op: Protocol.Op,
    private value: unknown,
  ) {}
  apply(options: Protocol.QueryOptions) {
    options.filters.push({ field: this.field, op: this.op, value: this.value });
  }
}

export class OrderByConstraint implements QueryConstraint {
  readonly type = 'orderBy';
  constructor(
    private field: string,
    private direction: 'asc' | 'desc',
  ) {}
  apply(options: Protocol.QueryOptions) {
    options.orderBy.push({ field: this.field, direction: this.direction });
  }
}

export class LimitConstraint implements QueryConstraint {
  readonly type = 'limit';
  constructor(private n: number) {}
  apply(options: Protocol.QueryOptions) {
    options.limit = this.n;
  }
}

export class SelectConstraint implements QueryConstraint {
  readonly type = 'select';
  constructor(private fields: string[]) {}
  apply(options: Protocol.QueryOptions) {
    options.fields.push(...this.fields);
  }
}

export class CursorConstraint implements QueryConstraint {
  readonly type: 'startAt' | 'startAfter' | 'endAt' | 'endBefore';
  constructor(
    type: 'startAt' | 'startAfter' | 'endAt' | 'endBefore',
    private value: unknown,
  ) {
    this.type = type;
  }
  apply(options: Protocol.QueryOptions) {
    options[this.type] = this.value;
  }
}
